module.exports = {"360827100":"泉江镇","360827101":"雩田镇","360827102":"碧洲镇","360827103":"草林镇","360827104":"堆子前镇","360827105":"左安镇","360827106":"高坪镇","360827107":"大汾镇","360827108":"衙前镇","360827109":"禾源镇","360827110":"汤湖镇","360827111":"枚江镇","360827200":"珠田乡","360827201":"巾石乡","360827202":"大坑乡","360827204":"双桥乡","360827205":"新江乡","360827206":"五斗江乡","360827207":"西溪乡","360827208":"南江乡","360827209":"黄坑乡","360827210":"戴家埔乡","360827211":"营盘圩乡","360827402":"遂川县工业园区","360827501":"五指峰林场","360827502":"云岭林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360827.json
// module id = 1212
// module chunks = 0